import { ApiService, Form } from '~/shared/api'
import { restGetList, sendForm } from '~/shared/utils/decorators'
import type { QueryParams, ServiceRestGetList, ServiceCanSendForm } from '~/shared/interfaces'
import { toModels } from '~/shared/api/utils'
import { ResponseListModel } from '~/model/Response'
import { AccountUserFromFileModel, AccountUserModel } from '~/model/AccountUsers'

interface DeleteUserResponse {
  data: {
    success: boolean
    message?: string
  }
}

// eslint-disable-next-line
interface AccountUsersService extends ServiceRestGetList, ServiceCanSendForm {}

@restGetList
@sendForm

// eslint-disable-next-line no-redeclare
class AccountUsersService extends ApiService {
  protected route: string = 'vacancies/manager/staffs'
  protected routeSearch: string = 'vacancies/manager/search-staff'
  protected routeDelete: string = '/api/v1/yavagro/vacancies/manager/remove-staff'
  protected routeAdd: string = '/api/v1/yavagro/vacancies/manager/assign-staff'
  protected routeAddManagersFromFile = '/api/v1/yavagro/vacancies/manager/assign-staffs-from-file'

  getUserList(params: QueryParams = {}): Promise<ResponseListModel> {
    return this.getList(params).then(({ data, total, lastPage, perPage }) => {
      if (Array.isArray(data)) {
        data = toModels(AccountUserModel)(data)
      }

      return { data, lastPage, perPage, total }
    })
  }

  searchUserItem(params: QueryParams = {}): Promise<Array<AccountUserModel>> {
    return this.getList(params, {}, this.routeSearch).then(toModels(AccountUserModel))
  }

  deleteUserItem(phone: string): Promise<boolean> {
    return this.requestService
      .request<DeleteUserResponse>({
        url: this.routeDelete,
        method: 'POST',
        data: { phone }
      })
      .then(response => {
        return response.data.data.success ?? false
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Ошибка удаления пользователя:', error)
        return false
      })
  }

  addUserItem(phone: string): Promise<boolean> {
    return this.requestService
      .request<DeleteUserResponse>({
        url: this.routeAdd,
        method: 'POST',
        data: { phone }
      })
      .then(response => {
        return response.data.data.success ?? false
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Ошибка добавления пользователя:', error)
        return false
      })
  }

  bulkAddManagersFromFile(file: Form): Promise<AccountUserFromFileModel> {
    return this.sendForm(file, this.routeAddManagersFromFile).then(data => {
      if (data?.data?.data) {
        return new AccountUserFromFileModel(data.data.data)
      }
      return new AccountUserFromFileModel(null)
    })
  }
}

export default AccountUsersService
